import { Checkbox } from '@/presentation/components/checkbox'
import { cn } from '@/presentation/utils'
import { useState } from 'react'
import type { HTMLAttributes } from 'react'
import type { AutoFormWidgetsProps } from '../autoForm'
import { FieldDescription } from '../description'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type CheckboxWidgetProps = AutoFormWidgetsProps & {
  initialValue?: HTMLAttributes<HTMLInputElement>['defaultValue']
}

export const CheckboxWidget = (props: CheckboxWidgetProps) => {
  const initial =
    props.initialValue === true ||
    props.initialValue === 'true' ||
    props.initialValue === 'on' ||
    props.initialValue === 1 ||
    props.initialValue === '1'
  const [checked, setChecked] = useState<boolean>(initial)

  return (
    <Field
      path={props.path}
      className={cn('flex flex-row items-center space-x-3 space-y-0', props.classNames?.root)}
    >
      {/* Ensure value is posted in FormData */}
      <input type="hidden" name={props.path} value={checked ? 'true' : 'false'} />
      <FieldControl>
        <Checkbox checked={checked} onCheckedChange={(v) => setChecked(v === true)} />
      </FieldControl>
      <div>
        <FieldLabel>{props.options?.label as string}</FieldLabel>
        <FieldDescription>{props.options?.description as string}</FieldDescription>
      </div>
      <FieldMessage />
    </Field>
  )
}
